import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
const Tab1 = ({
  SupplierName,
  SupplierGroup,
  SupplierType,
  Territory,
  IsTransporter,
  BillingCurrency,
  DefaultCompanyBankAccount,
  DefaultPriceList,
  IsInternalSupplier,
  RepresentsCompany,
  Website,
  SupplierDetails,
}) => {
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Input
              id="SupplierName"
              style={{
                height: "30px",
                border: SupplierName.Error ? "1px solid red" : "",
              }}
              label="Supplier Name"
              value={SupplierName.SupplierName}
              onChange={(e) => SupplierName.setSupplierName(e.target.value)}
            />
          </div>
        </div>

        <div className="col-3 ">
          <div className={SupplierGroup.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={SupplierGroup.SupplierGroup_list}
              
              label="Supplier Group"
              getOptionLabel={(item) =>
    item.isNew ? "+ Create New Supplier Group" : item.name
  }
  getOptionValue={(item) => item.name}
              createNewUrl="/master/suppliergroup/create-supplier"
  createNewLabel="Create New Supplier Group"
              value={SupplierGroup.select_SupplierGroup}
              onChange={(val) => SupplierGroup.setselect_SupplierGroup(val)}
            />
          </div>
        </div>
        <div className="col-3 ">
          <div className={SupplierType.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
  list={[{ name: "Company" }, { name: "Individual" }, { name: "Partnership" }]}
  
  label="Supplier Type"
  getOptionLabel={(item) => item.name}
  getOptionValue={(item) => item.name}
  value={SupplierType?.SupplierType || ""}
  onChange={(value) => SupplierType?.setSupplierType?.(value)}
/>
            
          </div>
        </div>
        <div className="col-3 ">
          <div className={Territory.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={Territory.Territory_list}
              style={{
                height: "30px",
              }}
              label="Territory"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={Territory.select_Territory}
              onChange={(val) => Territory.setselect_Territory(val)}
            />
          </div>
        </div>
        <div className="col-4 ">
          <div className="mb-3">
            <Checkbox
              id="IsTransporter"
              label="Is Transporter"
              value={IsTransporter?.IsTransporter || false}
              onChange={(val) => IsTransporter?.setIsTransporter?.(val)}
            />
          </div>
        </div>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Defaults</p>
        </div>

        <div className="col-4">
          <div className={BillingCurrency.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={BillingCurrency.BillingCurrency_list}
              style={{
                height: "30px",
                border: BillingCurrency.Error ? "1px solid red" : "",
              }}
              label="Billing Currency"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={BillingCurrency.select_BillingCurrency}
              onChange={(val) => BillingCurrency.setselect_BillingCurrency(val)}
            />
          </div>
        </div>

        <div className="col-4">
          <div
            className={
              DefaultCompanyBankAccount.Error ? `mb-3 errorborder` : `mb-3`
            }
          >
            <SelectSearch
              list={DefaultCompanyBankAccount.DefaultCompanyBankAccount_list}
              style={{
                height: "30px",
                border: DefaultCompanyBankAccount.Error ? "1px solid red" : "",
              }}
              label="Default Company Bank Account"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={DefaultCompanyBankAccount.select_DefaultCompanyBankAccount}
              onChange={(val) =>
                DefaultCompanyBankAccount.setselect_DefaultCompanyBankAccount(
                  val
                )
              }
            />
          </div>
        </div>
        <div className="col-4">
          <div className={DefaultPriceList.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={DefaultPriceList.DefaultPriceList_list}
              style={{
                height: "30px",
                border: DefaultPriceList.Error ? "1px solid red" : "",
              }}
              label="Default Price List"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={DefaultPriceList.select_DefaultPriceList}
              onChange={(val) =>
                DefaultPriceList.setselect_DefaultPriceList(val)
              }
            />
          </div>
        </div>

        <div className="col-4 ">
          <div className="mb-3">
            <Checkbox
              id="IsInternalSupplier"
              label="Is Internal Supplier"
              value={IsInternalSupplier?.IsInternalSupplier || false}
              // onChange={(val) =>
              //   IsInternalSupplier?.setIsInternalSupplier?.(val)
              // }
              onChange={(val) => {
    IsInternalSupplier?.setIsInternalSupplier?.(val);

    // Clear select value when unchecked
    if (!val) {
      RepresentsCompany?.setselect_RepresentsCompany?.(''); // or ''
    }
  }}
            />
          </div>
        </div>

        {IsInternalSupplier?.IsInternalSupplier && (
                  <>
                    <div className="col-4">
                      <div className="mb-3">
                        <SelectSearch
            list={RepresentsCompany.RepresentsCompany_list}
            style={{
              height: "30px",
              border: RepresentsCompany.Error ? "1px solid red" : "",
            }}
            label="Represents Company"
             getOptionLabel={(item) =>
    item.isNew ? "+ Create New Company" : item.name
  }
  getOptionValue={(item) => item.name}
              createNewUrl="/master/company/create-Company"
  createNewLabel="Create New Company"
            value={RepresentsCompany.select_RepresentsCompany}
            onChange={(val) => RepresentsCompany.setselect_RepresentsCompany(val)}
          />

                      </div>
                    </div>
                    
                  </>
                )}
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">More Information</p>
        </div>
        <div className="col-6">
          <div className="mb-3">
            <Input
              id="Website"
              style={{
                height: "30px",
                border: Website.Error ? "1px solid red" : "",
              }}
              label="Website"
              value={Website.Website}
              onChange={(e) => Website.setWebsite(e.target.value)}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-3">
            <Textarea
              style={{
                height: "150px",
                border: SupplierDetails?.Error ? "1px solid red" : "",
              }}
              label="Supplier Details"
              value={SupplierDetails.SupplierDetails}
              onChange={(e) =>
                SupplierDetails.setSupplierDetails(e.target.value)
              }
            />
            <p
              style={{
                paddingLeft: "14px",
                paddingRight: "14px",
                fontWeight: 400,
                fontSize: "9px",
                letterSpacing: "0",
                color: "#00000099",
                lineHeight:'2',
                fontFamily: "Roboto, sans-serif",
              }}
            >
              Statutory info and other general information about your Supplier
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tab1;
